import React, { useState, useEffect } from "react";
import {
  apiGetBrandAmbassadorBySourceId,
  apiGetSchedulePerformance,
} from "../../api/backend/brandAmbassador";

const columnHeaderMap = {
  timeSlot: "Hour",
  hourlySignups: "Signups/hr",
  cumulativeSignups: "Total Signups",
  hourlyEarnings: "Earnings/hr",
  cumulativeEarnings: "Total Earnings",
};
export default function AmbassadorPerformance({ currentUserId, role, refreshTrigger }) {
  const [ambassadorEvent, setAmbassadorEvent]     = useState(null);
  const [performanceData, setPerformanceData]     = useState([]);
  const [loadingEvent, setLoadingEvent]           = useState(true);
  const [loadingPerformance, setLoadingPerformance] = useState(false);
  const [error, setError]                         = useState(null);

  // 1) Load the latest BrandAmbassadorEvent
  useEffect(() => {
    if (role !== "brandAmbassador") {
      setLoadingEvent(false);
      return;
    }
    setLoadingEvent(true);
    apiGetBrandAmbassadorBySourceId(currentUserId)
      .then((res) => {
        const events = res.data || [];
        events.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setAmbassadorEvent(events[0] || null);
      })
      .catch((err) => {
        console.error(err);
        setError(err);
      })
      .finally(() => {
        setLoadingEvent(false);
      });
  }, [currentUserId, role]);

  // 2) Load its performance once we know the event
  useEffect(() => {
    if (!ambassadorEvent) return;
    setLoadingPerformance(true);
    apiGetSchedulePerformance(ambassadorEvent.id)
      .then((res) => {
        setPerformanceData(res.data || []);
      })
      .catch((err) => {
        console.error(err);
        setError(err);
      })
      .finally(() => {
        setLoadingPerformance(false);
      });
  }, [ambassadorEvent, refreshTrigger]);

  // 3) Show loaders or errors
  if (loadingEvent || loadingPerformance) {
    return <div>Loading performance data…</div>;
  }
  if (error) {
    return <div>Error loading performance data.</div>;
  }
  if (!performanceData.length) {
    return <p>Work in progress! You got this!!!</p>;
  }

  // 4) Render the table for the most recent date
  const sorted = [...performanceData].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );
  const latestDate = new Date(sorted[0].createdAt)
    .toISOString()
    .split("T")[0];
  const todaysRows = sorted.filter((r) =>
    new Date(r.createdAt).toISOString().startsWith(latestDate)
  );

  return (
    <section className="performance-section" style={{ marginBottom: 16 }}>
      <div className="performance-ux-style">
        <h2 className="performanceTitle">
          Schedule Performance Date: {new Date(latestDate).toLocaleDateString()}
        </h2>
      </div>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#444", color: "#fff" }}>
            {Object.entries(columnHeaderMap).map(([key, label]) => (
              <th key={key} style={{ border: "1px solid #666", padding: 8 }}>
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {todaysRows.map((row, i) => (
            <tr
              key={i}
              style={{ backgroundColor: i % 2 === 0 ? "#333" : "#222" }}
            >
              {Object.keys(columnHeaderMap).map((col) => (
                <td key={col} style={{ border: "1px solid #666", padding: 8 }}>
                  {col === "hourlyEarnings"
                    ? `$${Number(row[col]).toFixed(2)}`
                    : row[col]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
